import { render, staticRenderFns } from "./SignupSelector.vue?vue&type=template&id=ad0ab6a2&scoped=true"
import script from "./SignupSelector.vue?vue&type=script&lang=js"
export * from "./SignupSelector.vue?vue&type=script&lang=js"
import style0 from "./SignupSelector.vue?vue&type=style&index=0&id=ad0ab6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0ab6a2",
  null
  
)

export default component.exports